export { MOBILE_MEDIA_QUERY, isMobileViewport, useIsMobile } from '@netexknowledge/smart-components';
